/**
 * متنِ قالب‌دار — قرینه‌ی apps/mobile/src/ui/RichText.tsx.
 *
 * ورودی‌اش رشته نیست، بلکه بلوک‌هایی است که `core/lib/richText.ts` ساخته. این
 * عمدی است و کلِ نکته‌ی امنیتیِ WHOSUP-233 همین‌جاست: متنِ توضیح از سایتِ
 * غریبه می‌آید، پس هیچ‌جا `dangerouslySetInnerHTML` نداریم و هیچ رشته‌ای به
 * HTML تبدیل نمی‌شود. هر تکه یک گرهِ ری‌اکت است و مرورگر آن را متن می‌بیند،
 * نه نشانه‌گذاری.
 */
import React from 'react';
import type { RichBlock, RichSpan } from '@/core/lib/richText';

/** تکه‌های یک خط → گره‌های ری‌اکت. بولد و ایتالیک، و هیچ‌چیزِ دیگر. */
const line = (spans: RichSpan[]): React.ReactNode[] => spans.map((s, i) => {
  if (s.bold && s.italic) return <strong key={i}><em>{s.text}</em></strong>;
  if (s.bold) return <strong key={i}>{s.text}</strong>;
  if (s.italic) return <em key={i}>{s.text}</em>;
  return <React.Fragment key={i}>{s.text}</React.Fragment>;
});

export function RichText({ blocks }: { blocks: RichBlock[] }) {
  if (!blocks.length) return null;
  return (
    <div className="richtext">
      {blocks.map((b, i) => (b.kind === 'ul' ? (
        <ul key={i}>
          {b.lines.map((l, j) => <li key={j}>{line(l)}</li>)}
        </ul>
      ) : (
        <p key={i}>
          {/* خطِ تازه‌ی داخلِ یک پاراگراف. بدونِ این، HTML اینترها را جمع
              می‌کند و «ساعتِ باز شدنِ در» به «ساعتِ شروع» می‌چسبد. */}
          {b.lines.map((l, j) => (
            <React.Fragment key={j}>{j ? <br /> : null}{line(l)}</React.Fragment>
          ))}
        </p>
      )))}
    </div>
  );
}
